import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";

export const FulfillmentLocationCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  {
    header: "Fulfillment location",
    cell: (row) => {
      return row.originAddress.name || "";
    },
  };
